import { Language } from "@mui/icons-material";
import React, { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";

import LangIcon from "../../assets/images/Lang.png";
import { LANGUAGE } from "../../i18n";
import Button from "../elements/Button/Button";

interface I18nButtonProps {
	className?: string;
}

const I18nButton: React.FC<I18nButtonProps> = ({ className }) => {
	const { t, i18n } = useTranslation();
	const targetLanguage = i18n.language === LANGUAGE.CN ? LANGUAGE.EN : LANGUAGE.CN;

	const handleLanguageChange = useCallback(() => {
		i18n.changeLanguage(targetLanguage);
	}, [i18n, targetLanguage]);

	return (
		<Button onClick={handleLanguageChange} className={className} data-testid="I18nChangeBtn">
			<img src={LangIcon} alt="Language" className="I18nButtonIcon" draggable={false} />
			{t("language.label")}
		</Button>
	);
};

export default memo(I18nButton);
